import React from 'react';
import {Card, CardContent, Grid, Typography, Radio} from '@mui/material';

interface InstallmentCardProps {
    selected: boolean;
    onSelect: () => void;
    financialSupplierTitle: string;
    loanTemplateTitle?: string;
    amount: number;
    repaymentTitle: string;
    duration: string;
    status: string;
}

export default function InstallmentCard({
    selected,
    onSelect,
    financialSupplierTitle,
    loanTemplateTitle,
    amount,
    repaymentTitle,
    duration,
    status,
}: InstallmentCardProps) {
    return (
        <Card
            variant="outlined"
            sx={{
                // borderColor: selected ? '#BBA57A' : '#D7DBEC',
                p: 2,
                borderRadius: 2,
                // backgroundColor: selected ? '#f0f8ff' : '#fff',
            }}
            onClick={onSelect}
        >
            <CardContent sx={{paddingBottom: '8px !important'}}>
                <Grid container spacing={1}>
                    <Grid item xs>
                        <Typography fontWeight={400}>
                            <Radio
                                checked={selected}
                                onChange={onSelect}
                                sx={{
                                    '& .MuiSvgIcon-root': {
                                        fontSize: 30,
                                        color: '#BBA57A',
                                    },
                                }}
                            />
                            {financialSupplierTitle} {`(${duration})`}
                        </Typography>
                        {loanTemplateTitle && (
                            <Typography
                                variant="caption"
                                color="text.secondary"
                                sx={{marginRight: '50px'}}
                            >
                                {loanTemplateTitle}
                            </Typography>
                        )}
                    </Grid>
                </Grid>

                <Grid container mt={2} spacing={1} gap={2}>
                    <Grid
                        item
                        xs={12}
                        alignItems={'end'}
                        container
                        borderTop={{xs: '1.2px solid #D7DBEC'}}
                    >
                        <Grid xs={6}>
                            {' '}
                            <Typography variant="body2" color="text.secondary">
                                منبع تامین مالی
                            </Typography>
                        </Grid>
                        <Grid xs={6} textAlign={'left'}>
                            <Typography fontWeight={300}>
                                {financialSupplierTitle}{' '}
                            </Typography>
                        </Grid>
                    </Grid>
                    {/* borderLeft={{ md: "1.2px solid #D7DBEC", xs: 'unset' }} */}
                    <Grid
                        item
                        xs={12}
                        alignItems={'end'}
                        container
                        borderTop={{xs: '1.2px solid #D7DBEC'}}
                    >
                        <Grid xs={6}>
                            <Typography variant="body2" color="text.secondary">
                                مبلغ هر قسط (ریال)
                            </Typography>
                        </Grid>
                        <Grid xs={6} textAlign={'left'}>
                            <Typography fontWeight={300}>
                                {Number(amount)?.toLocaleString('fa')}
                            </Typography>
                        </Grid>
                    </Grid>

                    <Grid
                        item
                        xs={12}
                        alignItems={'end'}
                        container
                        borderTop={{xs: '1.2px solid #D7DBEC'}}
                    >
                        <Grid xs={6}>
                            <Typography variant="body2" color="text.secondary">
                                نوع بازپرداخت
                            </Typography>
                        </Grid>
                        <Grid xs={6} textAlign={'left'}>
                            <Typography fontWeight={300}>
                                {repaymentTitle}
                            </Typography>
                        </Grid>
                    </Grid>

                    <Grid
                        item
                        xs={12}
                        alignItems={'end'}
                        container
                        borderTop={{xs: '1.2px solid #D7DBEC'}}
                    >
                        <Grid xs={6}>
                            <Typography variant="body2" color="text.secondary">
                                وضعیت تسهیلات
                            </Typography>
                        </Grid>
                        <Grid xs={6} textAlign={'left'}>
                            <Typography fontWeight={300}>{status}</Typography>
                        </Grid>
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    );
}
